import { ISetup } from "@smartrr/shared/entities/Organization";
import { GettingStartedStep } from "../GettingStartedStep";

export class SubscriptionBlockStep extends GettingStartedStep {
  getOrder(): number {
    return 3;
  }

  protected deriveCompleted(setup: ISetup): boolean {
    return !!setup.onSiteSetup?.smartrrWidget?.completed;
  }
}
